import { motion } from 'framer-motion';
import { FileText, Loader2, MessageSquare, Network } from 'lucide-react';

const stages = [
  { icon: MessageSquare, label: 'Analyzing Video' },
  { icon: Network, label: 'Extracting Content' },
  { icon: Loader2, label: 'Generating Materials' },
  { icon: FileText, label: 'Preparing Output' },
];

export function Conversion() {
  return (
    <section className="bg-gradient-to-b from-white to-indigo-50/30 py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Watch the Magic Happen
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Our AI processes your video in real-time to create comprehensive study materials
          </p>
        </motion.div>
        <div className="mt-16">
          <div className="flex justify-center">
            <div className="grid gap-8 md:grid-cols-4 md:gap-12">
              {stages.map((stage, index) => (
                <motion.div
                  key={stage.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="relative text-center"
                >
                  <div className="flex justify-center">
                    <div className="relative">
                      <div className="absolute inset-0 animate-ping rounded-full bg-indigo-200"></div>
                      <div className="relative inline-flex rounded-full bg-indigo-100 p-4">
                        <stage.icon className="h-6 w-6 text-indigo-500" />
                      </div>
                    </div>
                  </div>
                  <h3 className="mt-4 font-medium text-gray-900">{stage.label}</h3>
                  {index < stages.length - 1 && (
                    <div className="absolute right-0 top-1/2 hidden h-px w-full -translate-y-1/2 bg-gradient-to-r from-indigo-200 to-transparent md:block"></div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}